import {
  Component,
  ElementRef,
  HostListener,
  inject,
  input,
  output,
  signal,
} from '@angular/core'
import { MatIcon } from '@angular/material/icon'
import { SelectMenuListComponent } from '../table/filters/select-menu-list/select-menu-list.component'
import { SelectMenuListItemComponent } from '../table/filters/select-menu-list-item/select-menu-list-item.component'
import { Option } from '../../shared/models/general'

@Component({
  imports: [MatIcon, SelectMenuListComponent, SelectMenuListItemComponent],
  selector: 'div[app-selector]',
  template: `
    <div class="wrapper" [class.slim]="slim()">
      <mat-icon
          class="select-icon"
          svgIcon="expand_more"
          (click)="toggle()"
      ></mat-icon>
      <input
          type="button"
          [placeholder]="'none'"
          [value]="selected()?.display || 'None Selected'"
          (click)="toggle()"
      />
      <div class="popover-anchor">
        <div class="popover" [class.open]="open()">
          <ul app-select-menu-list>
            <!-- SHOW SEARCH RESULTS -->
            @for (o of options(); track o.value; ) {
              <li
                  app-select-menu-list-item
                  [value]="o"
                  [display]="o.display"
                  [selected]="selected() === o"
                  [multi]="false"
                  (select)="setValue($event)"
              ></li>
            }
          </ul>
        </div>
      </div>
    </div>
  `,
  styles: `
    .wrapper {
      position: relative;
      width: 100%;
      padding: 0.5rem 0.75rem;
      border: 1px solid black;

      &.slim {
        padding: 0.5rem 0 0;
        border: none; 
      }
    }

    input {
      width: 100%;
      padding: 0.5rem 1.75rem 0.25rem 0.25rem;
      border: none;
      background: white;
      text-align: left;
      border-bottom: 1px solid black;
      font-size: 0.9rem;
      line-height: 1.25rem;

      &:focus {
        outline: none;
      }
    }

    .popover-anchor {
      position: relative
    }
  
    .popover {
      display: none;
      position: absolute;
    }

    .popover.open {
      z-index: 3;
      display: flex;
      flex-direction: column;
      min-height: 7rem;
      width: 300px;
      right: 0;
      top: calc(100% + 0.5rem);
      border: 1px solid black;
      border-radius: 0;
      padding: 0.5rem 1rem;
      background: white;


      &::before {
        content: ' ';
        border: none;
        border-top: 1px solid black;
        border-right: 1px solid black;
        width: 0.5rem;
        height: 0.5rem;
        transform: rotate(-45deg);
        position: absolute;
        top: calc(-0.25rem - 1px);
        background: linear-gradient(
          45deg, 
          rgba(255,255,255,0) 0%, 
          rgba(255,255,255,0) calc(50% - 1px), 
          rgba(255,255,255,1) calc(50% - 1px), 
          rgba(255,255,255,1) 100%
          );
        right: 1rem;
      }
    }

    .select-icon {
        position: absolute;
        top: 1rem;
        right: 0.25rem;
    }
  `,
})
export class SelectorComponent<T> {
  private readonly elementRef = inject(ElementRef)

  readonly options = input.required<readonly Option<T>[]>()
  readonly selected = input.required<Option<T> | undefined>()
  readonly label = input('')
  readonly slim = input(false)

  readonly selectedChange = output<Option<T>>()
  readonly open = signal(false)

  @HostListener('document:click', ['$event'])
  handleOutsideClick(event: Event) {
    if (this.open() && !this.elementRef.nativeElement.contains(event.target as Node)) {
      this.toggle()
    }
  }

  protected toggle() {
    this.open.set(!this.open())
  }

  setValue(event: Option<T>) {
    this.selectedChange.emit(event)
    this.open.set(false)
  }
}
